import { AxiosClient } from '@/service/axiosClient'
import type { IPortOnePrepared } from '@/lib/PortOne/portOne.types'
import {
  IPaymentComplete,
  IPaymentCompleteParam,
  IPaymentPrepareParam,
} from '@/service/models/payments'
import { AxiosResp } from '@/types'

/** 결제 API */
export const paymentApi = {
  /** 상품 결제 준비 */
  prepareProduct: (userId: number, productId: number, params: IPaymentPrepareParam) =>
    AxiosClient.post<AxiosResp<IPortOnePrepared>>(
      `/payments/users/${userId}/products/${productId}/prepare`,
      params
    ),

  /** 상품 결제 완료 확인 */
  completeProduct: (userId: number, productId: number, params: IPaymentCompleteParam) =>
    AxiosClient.post<AxiosResp<IPaymentComplete>>(
      `/payments/users/${userId}/products/${productId}/complete`,
      params
    ),
}
